import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TomosAndBonos() {
  const [activeTramo, setActiveTramo] = useState(0);
  const tramos = ['Inicial', '1° y 2°', '3° y 4°', '5° y 6°'];
  const tomos = [{
    num: 1,
    icon: '📘',
    name: 'Matemáticas'
  }, {
    num: 2,
    icon: '⚗️',
    name: 'Física y Química'
  }, {
    num: 3,
    icon: '🌿',
    name: 'Ciencias Biológicas'
  }, {
    num: 4,
    icon: '🌍',
    name: 'Ciencias de la Tierra'
  }, {
    num: 5,
    icon: '📖',
    name: 'Lengua Española'
  }, {
    num: 6,
    icon: '🏛️',
    name: 'Historia'
  }, {
    num: 7,
    icon: '🗺️',
    name: 'Geografía'
  }, {
    num: 8,
    icon: '⚖️',
    name: 'Ciudadanía'
  }];
  const bonos = [{
    tramo: 'TRAMO 1 · Educación Inicial',
    icon: '📘',
    items: ['Juego simbólico y las 8 áreas del EBI', 'Mensajes para familias listos', 'Actividades para el día difícil']
  }, {
    tramo: 'TRAMO 2 · 1° y 2° año',
    icon: '📗',
    items: ['Conciencia fonológica con rúbricas listas', 'Cuando el grupo no puede con la lectura', '1° y 2° juntos · cómo organizarlo']
  }, {
    tramo: 'TRAMO 3 · 3° y 4° año',
    icon: '📙',
    items: ['Historia y Ciudadanía integradas', 'Evaluaciones express para las 8 áreas', 'El sistema para el domingo libre']
  }, {
    tramo: 'TRAMO 4 · 5° y 6° año',
    icon: '📓',
    items: ['Bioética y genética en 6° año', 'Proyecto ciudadano listo para el egreso', 'Feria de Ciencias sin estrés']
  }];
  return <>
      {/* SECCIÓN 4: LOS TOMOS */}
      <section className="py-16 px-4 bg-brand-lightBlue" data-id="element-256">
        <div className="max-w-5xl mx-auto" data-id="element-257">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-brand-deep text-center mb-8" data-id="element-258">
            ¿Qué incluye cada tramo?
          </h2>

          <div className="flex flex-wrap justify-center gap-2 mb-10" data-id="element-259">
            {tramos.map((tramo, i) => <button key={i} onClick={() => setActiveTramo(i)} className={`px-6 py-2 rounded-full font-bold transition-colors ${activeTramo === i ? 'bg-brand-blue text-white shadow-md' : 'bg-white text-brand-text border border-brand-sky hover:bg-blue-50'}`} data-id="element-260">
                {tramo}
              </button>)}
          </div>

          <AnimatePresence mode="wait" data-id="element-261">
            <motion.div key={activeTramo} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.2
          }} data-id="element-262">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-263">
                {tomos.map((tomo, i) => <div key={i} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 text-center flex flex-col items-center justify-center aspect-square" data-id="element-264">
                    <div className="text-4xl mb-2" data-id="element-265">{tomo.icon}</div>
                    <div className="text-xs text-brand-gray font-bold uppercase tracking-wider mb-1" data-id="element-266">
                      Tomo {tomo.num}
                    </div>
                    <div className="font-bold text-brand-deep leading-tight" data-id="element-267">
                      {tomo.name}
                    </div>
                  </div>)}
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-brand-sky max-w-3xl mx-auto" data-id="element-268">
            <h3 className="text-xl font-display font-bold text-brand-deep mb-6 text-center" data-id="element-269">
              CADA TOMO INCLUYE:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-270">
              {['Planificación anual lista para el director/a', '7 bloques con todas las fichas del año', 'Actividades listas para el aula', 'Evaluaciones + rúbricas + autoevaluación', 'Registro grupal y seguimiento individual', 'Conexión con la realidad uruguaya', 'Alineado al Programa EBI · ANEP 2026'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-271">
                  <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-272" />
                  <span className="text-brand-text font-medium" data-id="element-273">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 5: BONOS */}
      <section className="py-16 px-4 bg-white" data-id="element-274">
        <div className="max-w-5xl mx-auto" data-id="element-275">
          <div className="text-center mb-12" data-id="element-276">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-deep mb-4" data-id="element-277">
              + 6 Bonos Estratégicos por tramo
            </h2>
            <p className="text-xl text-brand-text font-medium" data-id="element-278">
              Incluidos en todas las opciones · sin costo extra, a continuación
              3 ejemplos de cada tramo.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-279">
            {bonos.map((bono, i) => <div key={i} className="bg-brand-lightBlue rounded-2xl p-6 border border-brand-sky relative overflow-hidden" data-id="element-280">
                <div className="absolute top-0 right-0 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-281">
                  6 bonos incluidos
                </div>
                <h3 className="text-xl font-display font-bold text-brand-deep mb-4 flex items-center gap-2" data-id="element-282">
                  <span className="text-2xl" data-id="element-283">{bono.icon}</span> {bono.tramo}
                </h3>
                <ul className="space-y-3 mb-6" data-id="element-284">
                  {bono.items.map((item, j) => <li key={j} className="flex items-start gap-2 text-brand-text font-medium" data-id="element-285">
                      <span className="text-brand-orange" data-id="element-286">🎁</span> {item}
                    </li>)}
                </ul>
                <div className="flex items-center gap-3 pt-4 border-t border-brand-sky" data-id="element-287">
                  <span className="text-brand-gray line-through font-bold" data-id="element-288">
                    $990
                  </span>
                  <span className="text-brand-green font-display font-bold text-xl" data-id="element-289">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>

          <div className="bg-gradient-to-r from-[#FB8C00] to-[#EF6C00] text-white text-center p-6 rounded-2xl shadow-[0_8px_24px_rgba(245,124,0,0.3)] max-w-2xl mx-auto" data-id="element-290">
            <p className="text-xl md:text-2xl font-display font-bold mb-2" data-id="element-291">
              🎁 $990 en bonos por tramo — GRATIS
            </p>
            <p className="text-orange-100 font-medium" data-id="element-292">
              Incluidos en todas las opciones. Siempre.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 6: EL SEGUNDO ÁNGULO - EMPRENDIMIENTO */}
      <section className="py-20 px-4 bg-brand-deep text-white" data-id="element-293">
        <div className="max-w-4xl mx-auto" data-id="element-294">
          <div className="text-center mb-16" data-id="element-295">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-brand-orange mb-6" data-id="element-296">
              PERO ESPERÁ.
            </h2>
            <p className="text-xl md:text-2xl font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-297">
              Porque Aula de Éxitos no es solo para la maestra que quiere su año
              resuelto.
              <br data-id="element-298" />
              <br data-id="element-299" />
              Es también para la maestra que quiere que su año resuelto{' '}
              <span className="text-brand-orange font-bold text-[32px]" data-id="element-300">
                le genere dinero $$$.
              </span>
            </p>
          </div>

          <h3 className="text-2xl font-bold text-center mb-10" data-id="element-301">
            En Uruguay hay tres tipos de docentes que están leyendo esto:
          </h3>

          <div className="grid md:grid-cols-3 gap-6 mb-20" data-id="element-302">
            <div className="bg-white/10 border border-white/20 p-6 rounded-2xl" data-id="element-303">
              <h4 className="text-xl font-bold text-brand-orange mb-4" data-id="element-304">
                LA MAESTRA CON CARGO
              </h4>
              <p className="text-gray-300 text-sm mb-4" data-id="element-305">
                Amás tu trabajo pero odiás perder los domingos planificando.
                Querés tener el año resuelto · dar tus clases con confianza y
                recuperar tu tiempo personal.
              </p>
              <div className="pt-4 border-t border-white/10" data-id="element-306">
                <p className="font-bold text-sm" data-id="element-307">Lo que te da:</p>
                <p className="text-brand-sky text-sm" data-id="element-308">
                  Todo el año planificado en una tarde. Más tiempo para vivir ·
                  para tu familia · para lo que importa fuera del aula.
                </p>
              </div>
            </div>

            <div className="bg-white/10 border border-white/20 p-6 rounded-2xl" data-id="element-309">
              <h4 className="text-xl font-bold text-brand-orange mb-4" data-id="element-310">
                LA MAESTRA QUE QUIERE UN EXTRA
              </h4>
              <p className="text-gray-300 text-sm mb-4" data-id="element-311">
                Tenés cargo · pero el sueldo no alcanza. Querés dar clases
                particulares · pero la idea de preparar más material te
                paraliza.
              </p>
              <div className="pt-4 border-t border-white/10" data-id="element-312">
                <p className="font-bold text-sm" data-id="element-313">Lo que te da:</p>
                <p className="text-brand-sky text-sm" data-id="element-314">
                  400 actividades listas para usar en tus clases particulares.
                  Sin preparar nada extra. Con 4 horas de clases recuperás la
                  inversión.
                </p>
              </div>
            </div>

            <div className="bg-white/10 border border-white/20 p-6 rounded-2xl" data-id="element-315">
              <h4 className="text-xl font-bold text-brand-orange mb-4" data-id="element-316">
                LA MAESTRA EMPRENDEDORA
              </h4>
              <p className="text-gray-300 text-sm mb-4" data-id="element-317">
                No tenés cargo o elegiste la independencia. Querés que tu título
                sea la base de un negocio propio que genere ingresos reales.
              </p>
              <div className="pt-4 border-t border-white/10" data-id="element-318">
                <p className="font-bold text-sm" data-id="element-319">Lo que te da:</p>
                <p className="text-brand-sky text-sm" data-id="element-320">
                  La infraestructura completa para montar tu consultorio
                  pedagógico. Sistema · actividades · evaluaciones y registros
                  para mostrar resultados medibles.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white text-brand-deep p-8 md:p-10 rounded-3xl shadow-xl" data-id="element-321">
            <h3 className="text-2xl md:text-3xl font-display font-bold mb-8 text-center" data-id="element-322">
              La matemática del emprendimiento con MEGAPACK AULA DE EXITO
              BUSINESS
            </h3>

            <div className="space-y-6" data-id="element-323">
              <div className="flex flex-col md:flex-row items-center justify-between p-4 bg-brand-lightBlue rounded-xl" data-id="element-324">
                <div className="font-bold text-lg" data-id="element-325">
                  INVERSIÓN EN MEGAPACK AULA DE EXITOS BUSINESS
                </div>
                <div className="text-2xl font-display font-bold text-brand-orange" data-id="element-326">
                  $2.490 UYU
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6" data-id="element-327">
                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-328">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-329">
                    CON 4 HORAS DE CLASES PARTICULARES:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-330">
                    4 horas × $700 UYU = $2.800 UYU
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-331">
                    Recuperaste la inversión completa. El material te dura toda
                    la vida.
                  </p>
                </div>

                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-332">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-333">
                    CON 3 ALUMNOS MENSUALES:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-334">
                    3 alumnos × $2.800 UYU (paquete mensual)
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-335">
                    = $8.400 UYU por mes
                  </p>
                </div>

                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-336">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-337">
                    CON 8 ALUMNOS EN GRUPOS DE 4:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-338">
                    2 grupos × 4 niños × $450 × 4 sesiones
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-339">
                    = $14.400 UYU por mes
                  </p>
                </div>

                <div className="border border-gray-200 p-5 rounded-xl" data-id="element-340">
                  <h4 className="font-bold text-brand-blue mb-2" data-id="element-341">
                    CON EL PROGRAMA INTENSIVO DE VERANO:
                  </h4>
                  <p className="text-sm text-brand-text mb-2" data-id="element-342">
                    1 grupo de 5 niños × $3.500 × 3 semanas
                  </p>
                  <p className="text-sm font-bold text-brand-green" data-id="element-343">
                    = $52.500 UYU en 3 semanas
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}